import React, {useState} from 'react';
import './ModalUploadExel.scss';
import DynaModal from "../../Modal/DynaModal";
import {toast} from "react-toastify";
import {FileIcon} from "../../A13/HiSite/ExportIcons/ExportIcons";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";

const ModalUploadExel = ({onClose, setUpdateTableData}) => {

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("فایل اکسل را بارگذاری کنید");
  const [downloadLink, setDownloadLink] = useState("https://saden.varkan.ir/Logo/leadTemplate.xlsx");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploadSuccessful, setIsUploadSuccessful] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseData, setResponseData] = useState({})

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const excelFile = selectedFiles.find((file) =>
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.ms-excel'
    );

    if (excelFile) {
      setFile(excelFile);
      setFileName(excelFile.name);
    } else {
      toast.error('فرمت فایل نا معتبر است');
    }
  };

  const modalDataHandle = async () => {
    if (file) {
      setResponseMessage("")
      const formData = new FormData();
      formData.append("leads_file", file);

      try {
        const response = await _axios.post(
          prefixUrl() + "/hiSite/?request=uploadLeadExcel",
          formData,
          {
            onUploadProgress: (progressEvent) => {
              const {loaded, total} = progressEvent;
              const percentCompleted = Math.round((loaded * 100) / total);
              setUploadProgress(percentCompleted);
            },
          }
        );

        if (response.data?.status) {
          setIsUploadSuccessful(true);
          toast.success(response?.data?.message);
          setIsSuccess(true)
          setResponseMessage(response?.data?.message)
          setResponseData(response?.data?.data)
          setUpdateTableData(Math.random() * 13);
        } else {
          setIsUploadSuccessful(false);
          toast.error(response?.data?.message);
          setResponseMessage(response?.data?.message)
        }
      } catch (error) {
        setIsUploadSuccessful(false);
        toast.error('An error occurred while uploading the file.');
      } finally {
        setTimeout(() => {
          setUploadProgress(0);
          setIsUploadSuccessful(null);
        }, 2000);
      }
    }
  };

  return (
    <DynaModal onClose={onClose} className={'simple-modal-saden ModalUploadExel'}>

      <div className="header-modal">
        <p>بارگذاری فایل اکسل</p>
        <div onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
              fill="white"/>
            <path
              d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
              fill="white"/>
            <path
              d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
              fill="white"/>
          </svg>
        </div>
      </div>

      {!isSuccess ?
        <div className={"upload-section"}>
          <div className={"row-download"}>
            <a href={downloadLink} target={"_blank"}>دانلود فایل اکسل نمونه</a>
          </div>
          <div className={"parent-file-upload"}>
            <label> فایل اکسل</label>
            <button onClick={() => document.getElementById("exel").click()} className={"upload-file-but"}>
              {fileName}
            </button>
            <div className={"icon-side-but"}><FileIcon/></div>
            <input style={{display: "none"}} type={"file"} id={"exel"} accept=".xlsx, .xls"
                   onChange={(e) => handleFileChange(e)}/>
          </div>

          <div className="progress-bar">
            <div
              className="progress-bar-fill"
              style={{
                width: `${uploadProgress}%`,
                backgroundColor: isUploadSuccessful === false ? '#ff5648' : '#60c064',
              }}>
              {uploadProgress} %
            </div>
          </div>

          {/*{uploadProgress > 1 &&*/}
          {/*  <h5 style={{*/}
          {/*    right: `${uploadProgress}%`,*/}
          {/*  }}>{uploadProgress} % </h5>*/}
          {/*}*/}

          {responseMessage !== "" &&
            <div className={"show-response"}>
              <h6>{responseMessage}</h6>
            </div>
          }
        </div> :
        <div className={"response-vz"}>
          <h4>{responseMessage}</h4>
          <div className={"row-response"}>
            <div className={"inline-tex"}>
              <h3>تعداد کل : </h3>
              <h3>{responseData?.total}</h3>
            </div>
            <div className={"inline-tex"}>
              <h3>تعداد اضافه شده : </h3>
              <h3>{responseData?.submitted}</h3>
            </div>
            <div className={"inline-tex"}>
              <h3>تعداد تکراری : </h3>
              <h3>{responseData?.duplicate}</h3>
            </div>
          </div>
        </div>}

      <div className="button-modal">
        {!isSuccess ?
          <>
            <button onClick={onClose} className="cancel-saden-modal">انصراف</button>
            <button className="accept-saden-modal" disabled={+uploadProgress > 0} onClick={modalDataHandle}>ثبت</button>
          </> : <button onClick={onClose} className="accept-saden-modal">بستن</button>
        }

      </div>
    </DynaModal>
  );
};

export default ModalUploadExel;